import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toast"]

  connect() {
    this.toastTargets.forEach((toast, index) => {
      window.setTimeout(() => {
        toast.classList.add("opacity-0", "transition", "duration-300")
        window.setTimeout(() => toast.remove(), 300)
      }, 4000 + index * 150)
    })
  }
}
